import { store } from '../../../../../../../resources/frontend/js/store/index';

const getFieldInfo = name => {
    switch (name) {
        case 'zipcode':
            return {
                mask: 'zipcode',
                placeholder: store.state.page.translations['form-builder']['zipcode_1'],
                apiKey: 'postcode',
                component: 'zipcode',
                validator: 'zipcode',
            };
        case 'huisnummer':
            return {
                mask: 'numeric',
                placeholder: store.state.page.translations['form-builder']['housenumber'],
                apiKey: 'housenumber',
                component: 'house-number-old',
            };
        case 'straat':
            return {
                mask: '',
                placeholder: store.state.page.translations['form-builder']['street'],
                apiKey: 'street',
                component: 'street-old',
            };
        case 'plaats':
            return {
                mask: '',
                placeholder: store.state.page.translations['form-builder']['city'],
                apiKey: 'city',
                component: 'city-old',
            };
        case 'state':
            return {
                mask: '',
                placeholder: store.state.page.translations['form-builder']['state'],
                apiKey: 'state',
                component: 'states',
            };
    }
};

export const fields = countryCode => {
    switch (countryCode) {
        case 'nl':
            return {
                zipcode: getFieldInfo('zipcode'),
                huisnummer: getFieldInfo('huisnummer'),
            };
        case 'us':
            return {
                huisnummer: getFieldInfo('huisnummer'),
                straat: getFieldInfo('straat'),
                plaats: getFieldInfo('plaats'),
                state: getFieldInfo('state'),
                zipcode: getFieldInfo('zipcode'),
            };
        default:
            return {
                huisnummer: getFieldInfo('huisnummer'),
                straat: getFieldInfo('straat'),
                plaats: getFieldInfo('plaats'),
                zipcode: getFieldInfo('zipcode'),
            };
    }
};
